import Layout from '@/pages/layout/'

export const topBar = [
	{
		path:"/",
		name:"home",
		redirect:"/home",
		meta : {
			title:"首页",
		},
		component:Layout,
		children:[
			{
				path:"/home",
				name:"home",
				title:"首页",
				component:() => import('@/pages/home')
			},
			{
				path:"/tszt",
				name:"tszt",
				title:"特色专题",
				component:() => import('@/pages/tszt')
			},
			{
				path:"/news",
				name:"news",
				title:"新闻中心",
				component:() => import('@/pages/news')
			},
			{
				path:"/djgj",
				name:"djgj",
				title:"党建共建",
				component:() => import('@/pages/news')
			},
			{
				path:"/dwgk",
				name:"dwgk",
				title:"党务公开",
				component:() => import('@/pages/dwgk')
			},
			{
				path:"/tzgg",
				name:"tzgg",
				title:"通知公告",
				component:() => import('@/pages/dwgk')
			},
			{
				path:"/tjdj",
				name:"tjdj",
				title:"图解党建",
				component:() => import('@/pages/tjdj')
			}
			,
			{
				path:"/zcjd",
				name:"zcjd",
				title:"政策解读",
				component:() => import('@/pages/dwgk')
			},
			{
				path:"/djbk",
				name:"djbk",
				title:"党建百科",
				component:() => import('@/pages/djbk')
			},
			{
				path:"/djxx",
				name:"djxx",
				title:"党建学习",
				component:() => import('@/pages/djxx')
			},
			{
				path:"/djxxDetail",
				name:"djxxDetail",
				title:"党建学习详情",
				component:() => import('@/pages/djxx/djxxDetail.vue')
			},
			{
				path:"/djxxResouce",
				name:"djxxResouce",
				title:"党建学习资源",
				component:() => import('@/pages/djxx/roucePlay.vue')
			},
			{
				path:"/djxxResouce2",
				name:"djxxResouce2",
				title:"党建学习资源",
				component:() => import('@/pages/djxx/roucePlay2.vue')
			},
			
			{
				path:"/bnds",
				name:"bnds",
				title:"百年党史",
				component:() => import('@/pages/bnds/index.vue')
			},
			
			{
				path:"/jspx",
				name:"jspx",
				title:"精神谱系",
				component:() => import('@/pages/jspx/index.vue')
			},
			// {
			// 	path: '/twienty',
			// 	name: '聚焦二十大',
			// 	component: () => import('@/pages/zlits/twienty/twienty.vue'),
			// 	meta:{
			// 		activeMenu:'/twienty'
			// 	}
			// },  
			{
				path: '/ztpx',
				name: 'ztpx',
				title:'专题培训',
				component: () => import('@/pages/ztpx/index.vue'),
			},  
			{
				path: '/szpx',
				name: 'szpx',
				title:'师资培训',
				component: () => import('@/pages/szpx/index.vue'),
			},  
			{
				path: '/ztpxDetail',
				name: 'ztpxDetail',
				title:'专题培训详情',
				component: () => import('@/pages/ztpx/ztpxDetail.vue'),
			},  
			{
				path: '/yxzl',
				name: 'yxzl',
				title:'院校专栏',
				component: () => import('@/pages/yxzl/index.vue'),
			},  
			{
				path: '/shyk',
				name: 'shyk',
				title:'三会一课',
				component: () => import('@/pages/shyk/index.vue'),
			},
			{
				path: '/zzshDetail',
				name: 'zzshDetail',
				title:'组织生活详情',
				component: () => import('@/pages/shyk/zzshDetail.vue'),
			}, 
			// 组织生活资源播放
			{
				path: '/roucePlay',
				name: 'roucePlay',
				title:'资源播放',
				component: () => import('@/pages/shyk/roucePlay.vue'),
			}, 
			 {
			 	path:"/xwxq",
			 	name:"xwxq",
			 	title:"新闻详情",
			 	component:() => import('@/pages/news/newDetail.vue')
			},
			 {
			 	path:"/rsd_detail",
			 	name:"rsd_detail",
			 	title:"二十大详情",
			 	component:() => import('@/pages/rsd_detail/rsd_detail.vue')
			},
			{
				path:"/tidj_detail",
				name:"tidj_detail",
				title:"图解党建详情",
				component:() => import('@/pages/tjdj/tjdjDetail.vue')
		   },
		   {
			path:"/tzgg_detail",
			name:"tzgg_detail",
			title:"通知公告详情",
			component:() => import('@/pages/dwgk/tzggDetail.vue')
	          },
		   {
			path:"/tssz",
			name:"tssz",
			title:"图说时政",
			component:() => import('@/pages/tssz')
	       },
		  
		   {
			path:"/sxylList",
			name:"sxylList",
			title:"思想引领列表",
			component:() => import('@/pages/zlits/sxyl.vue')
	       },
		   {
			path:"/pdf_play",
			name:"pdf_play",
			title:"pdf资源",
			component:() => import('@/pages/zlits/pdfDetail.vue')
	       },
		   {
			path:"/xxjdList",
			name:"xxjdList",
			title:"学习解读列表",
			component:() => import('@/pages/zlits/xxjd.vue')
	       },
		   {
			path:"/tjhb",
			name:"tjhb",
			title:"图解海报",
			component:() => import('@/pages/zlits/tjhb.vue')
	       }, {
			path:"/tjhb_detail",
			name:"tjhbdetail",
			title:"图解海报详情",
			component:() => import('@/pages/zlits/tjhbDetail.vue')
	       },
		  
		  
		   {
			path:"/xsx",
			name:"xsx",
			title:"习思想",
			component:() => import('@/pages/xsx')
	       },
		   {
			path:"/xsxDeyail",
			name:"xsxDeyail",
			title:"习思想详情",
			component:() => import('@/pages/xsx/roucePlay.vue')
	       },
		   {
			path:"/special",
			name:"special",
			title:"专题",
			component:() => import('@/pages/special/index.vue')
	       },
		   {
			path:"/sjgc",
			name:"sjgc",
			title:"三进工程",
			component:() => import('@/pages/sjgc/index.vue')
	       },
		   {
			path:"/search",
			name:"search",
			title:"搜索",
			component:() => import('@/pages/search/index.vue')
	       },
		   {
			path:"/bxzy",
			name:"bxzy",
			title:"本校资源",
			component:() => import('@/pages/bxzy/index.vue')
	       },
		   {
			path:"/tree",
			name:"tree",
			title:"智慧树课程",
			component:() => import('@/pages/bxzy/tree.vue')
	       },
		   {
			path:"/pdfPlay",
			name:"pdfPlay",
			title:"资源浏览",
			component:() => import('@/pages/pdfPlay/roucePlay.vue')
	       },
		   {
			path:"/pdfPlay2",
			name:"pdfPlay2",
			title:"资源浏览",
			component:() => import('@/pages/pdfPlay/roucePlay2.vue')
	       },
	  		// },
			// {
			// 	path:"/news",
			// 	name:"news",
			// 	title:"新闻公告",
			// 	component:() => import('@/pages/news')
			// },
			// {
			// 	path:"/yxfc",
			// 	name:"yxfc",
			// 	title:"院校风采",
			// 	component:() => import('@/pages/yxfc')
			// },
			// ,
			// {
			// 	path:"/xwxq",
			// 	name:"xwxq",
			// 	title:"新闻详情",
			// 	component:() => import('@/pages/news_play/index')
			// },

			// {
			// 	path:"/gxyxList",
			// 	name:"gxyxList",
			// 	title:"院校列表",
			// 	component:() => import('@/pages/gxyxList')
			// },
			// {
			// 	path:"/szzy",
			// 	name:"szzy",
			// 	title:"思政资源",
			// 	component:() => import('@/pages/szzy')
			// },
			// {
			// 	path:"/kcsz",
			// 	name:"kcsz",
			// 	title:"思政课程",
			// 	component:() => import('@/pages/kcsz')
			// },
			// {
			// 	path:"/szjk",
			// 	name:"szjk",
			// 	title:"思政金课",
			// 	component:() => import('@/pages/szjk')
			// },
			// {
			// 	path:"/szjkDetail",
			// 	name:"szjkDetail",
			// 	title:"思政金课详情",
			// 	component:() => import('@/pages/szjk/szjkDetail')
			// },
			// {
			// 	path:"/sfk_play",
			// 	name:"sfk_play",
			// 	title:"示范课详情",
			// 	component:() => import('@/pages/sfk_play')
			// },
			// {
			// 	path:"/resource_play",
			// 	name:"resource_play",
			// 	title:"资源详情",
			// 	component:() => import('@/pages/resource_play')
			// },
			// ,
			// {
			// 	path:"/dyztplay",
			// 	name:"dyztplay",
			// 	title:"资源详情",
			// 	component:() => import('@/pages/resource_play/dyzt')
			// },
			// {
			// 	path:"/news_play",
			// 	name:"news_play",
			// 	title:"新闻详情",
			// 	component:() => import('@/pages/news_play')
			// },
			// {
			// 	path:"/szkc",
			// 	name:"szkc",
			// 	title:"思政课程",
			// 	component:() => import('@/pages/szkc')
			// },
			// {
			// 	path:"/sfzx",
			// 	name:"sfzx",
			// 	title:"示范中心",
			// 	component:() => import('@/pages/sfzx'),
				
					
				
			// },
			// {
			// 	path:"/sfzx/sfjd",
			// 	name:"sfjd",
			// 	title:"示范基地",
			// 	component:() => import('@/pages/sfzx/sfjd'),
			// 	children:[
			// 		{
			// 			path:"/",
			// 			name:"jdjj",
			// 			title:"基地主页",
			// 			component:() => import('@/pages/sfzx/sfjd/home'),
			// 		},
			// 		{
			// 			path:"/sfzx/sfjd/jdjj",
			// 			name:"jdjj",
			// 			title:"基地简介",
			// 			component:() => import('@/pages/sfzx/sfjd/jdjj'),
			// 		},
			// 		{
			// 			path:"/sfzx/sfjd/jdhd",
			// 			name:"jdhd",
			// 			title:"基地活动",
			// 			component:() => import('@/pages/sfzx/sfjd/jdhd'),
			// 		}
			// 		,
			// 		{
			// 			path:"/sfzx/sfjd/cgal",
			// 			name:"jdhd",
			// 			title:"成果案例",
			// 			component:() => import('@/pages/sfzx/sfjd/cgal'),
			// 		}
			// 	]
			
			// },
			// {
			// 	path:"/gjgx",
			// 	name:"gjgx",
			// 	title:"共建共享",
			// 	component:() => import('@/pages/gjgx'),
			// },
			// {
			// 	path:"/gjgx/gjlb",
			// 	name:"list",
			// 	title:"共建列表",
			// 	component:() => import('@/pages/gjgx/gjlb')
			// },
			// ,
			// {
			// 	path:"/szpx",
			// 	name:"szpx",
			// 	title:"师资培训",
			// 	component:() => import('@/pages/szpx'),
			// },
			// ,
			// {
			// 	path:"/ppjs",
			// 	name:"ppjs",
			// 	title:"品牌建设",
			// 	component:() => import('@/pages/ppjs'),
			// 	children:[
			// 		{
			// 			path:"/",
			// 			name:"yrpp",
			// 			title:"育人品牌",
			// 			component:() => import('@/pages/ppjs/yrpp'),
			// 		},
			// 		{
			// 			path:"/ppjs/kcyr",
			// 			name:"kcyr",
			// 			title:"课程育人",
			// 			component:() => import('@/pages/ppjs/kcyr'),
			// 		},
			// 		{
			// 			path:"/ppjs/whyr",
			// 			name:"jdhd",
			// 			title:"文化育人",
			// 			component:() => import('@/pages/sfzx/sfjd/jdhd'),
			// 		}
			// 		,
			// 		{
			// 			path:"/ppjs/sjyr",
			// 			name:"sjyr",
			// 			title:"红色云游",
			// 			component:() => import('@/pages/ppjs/sjyr'),
			// 		}
			// 	]
			// },
			// 实践基地
			// {
				
			// 	path:"/sjjd",
			// 	name:"list",
			// 	title:"实践基地",
			// 	component:() => import('@/pages/sjjd')
			
			// },
			// // 行走的思政课
			// {
			// 	path:"/xzszk",
			// 	name:"xzszk",
			// 	title:"行走思政课",
			// 	component:() => import('@/pages/xzszk/home'),
			// },
			// {
			// 	path:"/hshb",
			// 	name:"hshb",
			// 	title:"红色航标",
			// 	component:() => import('@/pages/xzszk/hshb'),
			// },
			// {
			// 	path:"/xfjs",
			// 	name:"xfjs",
			// 	title:"雪峰精神",
			// 	component:() => import('@/pages/xzszk/xfjs'),
			// },
			// {
			// 	path:"/hszj",
			// 	name:"hszj",
			// 	title:"红色足迹",
			// 	component:() => import('@/pages/xzszk/hszj'),
			// },
			// {
			// 	path:"/fxwk",
			// 	name:"fxwk",
			// 	title:"复兴文库",
			// 	component:() => import('@/pages/xzszk/fxwk'),
			// },
			// // 共建共享详情页面
			// {
			// 	path:"/gjgxdetail",
			// 	name:"gjgxdetail",
			// 	title:"共建详情",
			// 	component:() => import('@/pages/sfk_play/gjgx_play.vue'),
			// },
		]
	},
	{
		path:"/hsqj",
		name:"红色全景",
		meta:{
			template:288
		},
		component:() => import(/* webpackChunkName: 'pages' */ "@/pages/hsqj/hsqj"),
	},
	{
		path:"/hsqjPlayer",
		name:"红色全景",
		meta:{
			template:''
		},
		component:() => import(/* webpackChunkName: 'pages' */ "@/pages/hsqj/playar"),
	},
	{
		path:"/hsqjList",
		name:"红色全景",
		meta:{
			template:''
		},
		component:() => import(/* webpackChunkName: 'pages' */ "@/pages/hsqj/hsqjList"),
	},
	{
		path:"*",
		name:"error",
		meta:{
			title:"错误"
		},
		component: () => import('@/pages/error') 
	},
	{
		path:"/djxc",
		name:"党建宣传",
		meta:{
			template:289
		},
		component:() => import(/* webpackChunkName: 'pages' */ "@/pages/djxc/djxc.vue"),
	},
	{
		path:"/admin",
		name:"后台",
		
		component:() => import(/* webpackChunkName: 'pages' */ "@/pages/admin/index.vue"),
	},
]

export const routers = topBar